import { getTextStyleClasses } from '@/lib/typography';
import { cn } from '@/lib/utils';
import styles from './fieldChrome.module.css';

/** Label, control, helper, and error stack. 8px matches the label-to-control step. */
export const FIELD_STACK_CLASS = styles.stack;

export const FIELD_ERROR_CLASS = cn(getTextStyleClasses('caption', false), styles.error);

/**
 * Stacked (label / control / helper / error) layout is chosen from whether the caller passes
 * `error` or `helperText` at all, not from its value. A form wiring `error={errors.x?.message}` therefore keeps
 * one stable tree while the message toggles, so the control never remounts and keeps focus.
 */
export function hasFieldChrome(
  props: object,
  label: unknown,
  helperText: unknown,
): boolean {
  return Boolean(label || helperText) || 'helperText' in props || 'error' in props;
}
